<template>
  <div>
    <h3>Survey Types</h3>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none mt-8" id="profile-tabs" :key="isSmallerScreen">

      <!-- SURVEY -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Surveys' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <survey-list />
        </div>
      </vs-tab>

      <!-- QUIZ -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Quizzes' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <quiz-list />
        </div>
      </vs-tab>

      <!-- CHECKLIST -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Checklists' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <checklist-list />
        </div>
      </vs-tab>

      <!-- VENUE VISIT -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Venue Visits' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <venue-visit-list />
        </div>
      </vs-tab>

      <!-- ONLINE TRAINING -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Online Training' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <online-training-list />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import SurveyList from './SurveyList.vue'
import QuizList from './QuizList.vue'
import ChecklistList from './ChecklistList.vue'
import VenueVisitList from './VenueVisitList.vue'
import OnlineTrainingList from './OnlineTrainingList.vue'

export default {
  components: {
    SurveyList,
    QuizList,
    ChecklistList,
    VenueVisitList,
    OnlineTrainingList
  },
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },

  created() {
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
